import AuthStore from 'bz-stores/lib/auth-store';
import React from 'react';
import { WhatIsAPassKey } from './WhatIsAPassKey';
import { WhatIsMFA } from './WhatIsMFA';
import { WhatIsSMS } from './WhatIsSMS';
import { MfaMode } from './index';

interface IProps {
  onToggle: (mode: MfaMode) => void;
}

export function Intro({ onToggle }: IProps) {
  const { twoFactorAllowSms } = AuthStore.user;
  return (
    <div>
      <h3 className="mb-4 text-3xl font-bold">
        Your are required to setup Multi Factor Authentication
      </h3>
      <p className="mb-6 text-base">
        Your system administrator has setup Multi Factor Authentication, and requires you to set it
        up for your login.
      </p>
      <div className="flex flex-col items-center">
        <button className="btn mt-2" onClick={() => onToggle(MfaMode.app)}>
          Setup an authenticator app
        </button>
        <WhatIsMFA />
        {twoFactorAllowSms && (
          <>
            <button className="btn mt-2" onClick={() => onToggle(MfaMode.sms)}>
              Setup SMS Authentication
            </button>
            <WhatIsSMS />
          </>
        )}
        <button className="btn mt-2" onClick={() => onToggle(MfaMode.passkey)}>
          Setup a Passkey
        </button>
        <WhatIsAPassKey />
      </div>
    </div>
  );
}
